import { createContext, RefObject, useContext } from "react";
import type { MemeTemplate } from "types/meme";

export const MemeEditorProviderContext = createContext<{
    canvasContainerRef?: RefObject<HTMLDivElement>;
    itemsContainerRef?: RefObject<HTMLDivElement>;
    shadowParentContainerRef?: RefObject<HTMLDivElement>;
    shadowItemsContainerRef?: RefObject<HTMLDivElement>;
    initialMemes: Array<MemeTemplate>;
    defaultMeme?: MemeTemplate;
    isEditPage?: boolean;
}>({ initialMemes: [] });

export const useMemeEditor = () => useContext(MemeEditorProviderContext);
